module.exports = __webpack_public_path__ + "media/images/dalyviai-038a81d1.svg";